import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { push } from 'connected-react-router';
import { isEmpty, get, merge } from 'lodash';
import classNames from 'classnames';
import Select from 'react-select-legacy';

import Search from '../../components/filters/Search';
import { getPlayersIndexedOptions } from '../../selectors';
import { loadPlayerFilters, loadPlayersFilters } from '../../actions';
import { surveysFilterChange } from '../../actions/internal';
import { linkWithParams } from '../../routes';
import { hideModal } from '../../actions/internal';

class ASQModal extends React.Component {
  componentDidMount() {
    const playerId = get(this.props.meta, 'playerId');
    if (playerId) {
      this.props.onPlayerChange({value: playerId});
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onStartASQ(this.props.meta.playerId, this.props.meta.qId, this.props.location, this.props.meta.scroll);
  }

  render() {
    const { meta } = this.props;
    const btnCls = classNames(
      'o-sp-button o-sp-button--base o-sp-button--primary o-sp-button--block',
      { 'u-disabled': !meta.qId }
    );
    const qCls = classNames('o-select', { 'u-disabled': !meta.qId });
    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('modals.startAsq')}</b></h2>
        <hr className='u-margin-top--zero'/>
        <form className='row' onSubmit={this.handleSubmit}>
          <div className='column small-12 medium-6 large-4'>
            <Search value={meta.playerId}
              options={meta.players}
              onChange={this.props.onPlayerChange}
              onFilter={this.props.onPlayerFilter}
              filterOptions={this.props.filterOptions} />
          </div>
          <div className='column small-12 medium-6 large-4'>
            <Select
              name='qId'
              className={qCls}
              clearable={false}
              value={meta.qId || ''}
              onChange={this.props.onSurveyChange}
              options={meta.questionnaires || []}
              disabled={!meta.playerId || isEmpty(meta.questionnaires) }/>
          </div>
          <div className='column small-12 u-margin-top--base'>
            <button type='submit' className={btnCls}>
              {this.props.t('modals.startAsq')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    meta: state.modal.meta,
    location: state.router.location,
    filterOptions: getPlayersIndexedOptions(state.modal.meta),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onPlayerFilter: (search) => {
      dispatch(loadPlayersFilters(search, 'modal', true));
    },
    onPlayerChange: (selectedOption) => {
      const value = selectedOption && selectedOption.value;
      dispatch(loadPlayerFilters(value));
    },
    onSurveyChange: (selectedOption) => {
      const value = selectedOption && selectedOption.value;
      dispatch(surveysFilterChange(value));
    },
    onStartASQ: (playerId, qId, from, scroll) => {
      dispatch(hideModal());
      if (scroll) merge(from, { state: { scroll } });
      dispatch(push({ pathname: linkWithParams('asq', { player_id: playerId, id: qId }), state: { from } }))
    },
  }
}

ASQModal.propTypes = {
  filterOptions: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  onPlayerChange: PropTypes.func.isRequired,
  onPlayerFilter: PropTypes.func.isRequired,
  onStartASQ: PropTypes.func.isRequired,
  onSurveyChange: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ASQModal))
